///jacques-andre-editeur\proshop-v2\frontend\src\components\BookCard.jsx
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import { addToCart } from '../slices/cartSlice';

const Book = ({ book, showPanier }) => {
  const dispatch = useDispatch();

  const qty = 1;

  const [showMessage, setShowMessage] = useState(false);

  const addToCartHandler = () => {
    dispatch(addToCart({ ...book, qty }));
    setShowMessage(true);
    setTimeout(() => {
      setShowMessage(false);
    }, 2000); // 2 secondes
  };


  return (
    <div className='bookCardBox'>
      <Link to={`/livre/${book.slug}`} className='book-card-link' title={book.title}>
        <div className='book-card-img-container'>
          <img src={book.cover} variant='top' className='book-card-img' alt={book.title}/>  
        </div>
        <div className='book-card-text'>
          <div className='book-card-title'>{book.title}</div>
          <p className="book-card-auteurs">
            {book.author1 && book.author1.lastName && book.author1.isVisible ? (              
              <span>{book.author1.firstName} {book.author1.lastName}</span>
            ) : (
              <span>Auteur non renseigné</span>
            )}
            {book.author2 && book.author2.lastName && book.author2.isVisible && (
              <>, <span>{book.author2.firstName} {book.author2.lastName}</span></>
            )}
          </p>
        </div>
      </Link>
      <div className='book-card-text'>
        {book?.booksCollection?.name && book?.booksCollection?.name?.trim().toLowerCase() !== 'hors collection' &&
         (
          <Link to={`/collection/${book.booksCollection?.slug}`} className="book-card-collection">Collection {book.booksCollection.name}</Link>
         )         
        }    
        {book?.price && (<p className="bookPrice">{book?.price} €</p>)}
      </div>
      {showPanier && (
        <>
          <button
            className='addToCartButton'
            type='button'
            disabled={book.countInStock === 0}
            onClick={addToCartHandler}
          >
            Ajouter au panier
          </button>
          
          {showMessage && (
            <p className="confirmationMessage">Panier mis à jour</p>
          )}
        </>
      )}
    </div>
  );
};

export default Book;
